import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { QRCode } from "react-qrcode-logo";
import LinkButton from "components/LinkButton";
export default function QrCode({ qrUrl }) {
    const qrCodeRef = useRef(null);
    const cdnUrl = window.Chuffed && window.Chuffed.CDN.assets;
    const logoUrl = `${cdnUrl}/images/logo-square.png`;
    const downloadCode = () => {
        var _a;
        (_a = qrCodeRef.current) === null || _a === void 0 ? void 0 : _a.download("jpg", "chuffed-qr-code");
    };
    return (_jsxs("div", { className: "flex flex-col mt-2", "data-testid": "qr-code", children: [_jsx(QRCode, { value: qrUrl, enableCORS: true, quietZone: 50, logoImage: logoUrl, logoWidth: 350, eyeRadius: 10, fgColor: "#333333", size: 1050, style: {
                    borderRadius: "10px",
                    border: "2px solid #CCC",
                    margin: "0 auto",
                    maxWidth: "200px",
                    maxHeight: "200px",
                }, ref: qrCodeRef }), _jsx("div", { className: "my-2", children: _jsx(LinkButton, { isBold: true, look: "primary", onClick: downloadCode, size: "large", "data-testid": "qr-code-button", children: "Download" }) })] }));
}
